/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAggiuntivi
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAggiuntiviCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Dati anagrafici originali (non filtrati o modificati a BE) legati alla pratica
     */
    this.datiAnagraficiOriginali = null;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Elenco dei valori selezionabili per il campo TAE
     */
    this.tae = [];

    /**
     * Flag che indica se il paese spedizione è editabile
     */
    this.paeseSpedizioneReadOnly = true;

    /**
     * Elenco dei comuni selezionabili per l'ente rilascio
     */
    this.comuniEnteRilascio = [];

    /**
     * Elenco delle province selezionabili per l'ente rilascio
     */
    this.provinceEnteRilascio = [];

    /**
     * Elenco degli enti selezionabili
     */
    this.entiRilascio = [];

    /**
     * Ente rilascio selezionato
     */
    this.enteRilascio = null;

    /**
     * Indirizzo prevalorizzazione
     */
    this.indirizzoPrevalorizzazione = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        !self.anagraficaIncompleta &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tae &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
      );
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori, isDocumentoIdentita) {
      var provincia = '';
      if (!isDocumentoIdentita) {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;
      } else {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice;
      }

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        if (!self.isDocumentoIdentita) {
          self.comuni = [];
        } else {
          self.comuniEnteRilascio = [];
        }
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        if (!isDocumentoIdentita) {
          self.comuni = domain;
        } else {
          self.comuniEnteRilascio = domain;
        }
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    function recuperaProvinceImpl() {
      return self.domainSrvc.promiseDomain('PROVINCIA').finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * @ngdoc method
     * @name recuperaProvinciaEnteRilascio
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le province per l'ente rilascio
     */
    this.recuperaProvinciaEnteRilascio = function () {
      self.spinner.showSpinner++;

      recuperaProvinceImpl().then(function (domain) {
        self.provinceEnteRilascio = domain;
      });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice === '086') {
            self.provinceEnteRilascio = responses[1];
            self.provinceEnteRilascio = self.provinceEnteRilascio.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.provinceEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice = '**';
            // Devo forzare la chiamata di onProvinciaChange perché non "sente" la valorizzazione
            self.onProvinciaChange();
          }
          self.tae = responses[2];

          // Riordina tae in ordine alfabetico
          self.tae.sort(function (a, b) {
            if (a.descrizione > b.descrizione) {
              return 1;
            } else if (a.descrizione === b.descrizione) {
              return 0;
            } else {
              return -1;
            }
          });

          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];
          // Se l'ente di rilascio è stato prevalorizzato allora devo aggiornarlo attraverso l'onChange
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) {
            self.onEnteChange();
          }
          self.recuperaComuni(false, false);

          // Se è presente il valore provinciaRilascio, viene prevalorizzato nella select
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice !== '**'
          ) {
            self.recuperaComuni(false, true);
          }

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // fix CDICDDI-171 (indirizzo nazione spedizione == italia --> Forzato)
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * Funzione chiamata al change di provincia di documento identità. Setta correttamente la provincia
     * selezionata nel service e chiama recupera comuni
     */
    this.onProvinciaChange = function () {
      for (var i = 0; i < self.provinceEnteRilascio.length; i++) {
        if (
          self.provinceEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.descrizione =
            self.provinceEnteRilascio[i].descrizione;
          break;
        }
      }
      self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice = null;
      // Seleziona di provincia come stato estero
      if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice === '**') {
        self.comuniEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice = '**';
      } else {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice) {
          self.recuperaComuni(false, true);
        } else {
          self.comuniEnteRilascio = [];
        }
      }
    };

    /**
     * Funzione chiamata al change di comune di documento identità. Setta correttamente il comune
     * selezionato nel service
     */
    this.onComuneChange = function () {
      for (var i = 0; i < self.comuniEnteRilascio.length; i++) {
        if (
          self.comuniEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.descrizione =
            self.comuniEnteRilascio[i].descrizione;
          break;
        }
      }
    };

    /**
     * Funzione chiamata al change di ente di documento identità. Setta correttamente l'ente
     * selezionato nel service
     */
    this.onEnteChange = function () {
      if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi = null;
        return;
      }
      for (var i = 0; i < self.entiRilascio.length; i++) {
        if (
          self.entiRilascio[i].enteRilascio ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id =
            self.entiRilascio[i].id;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento =
            self.entiRilascio[i].tipoDocumento;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi =
            self.entiRilascio[i].codiceEnteNexi;
          break;
        }
      }
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      self.spinner.showSpinner++;
      $q.all([
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDatiAggiuntivi(self.idPratica),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagrafica(self.idPratica)
      ])
        .then(function (responses) {
          // Dati già salvati
          if (responses[0] && responses[0].data && !self.messaggiFctr.processaResponse(responses[0])) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = responses[0].data.result;

            self.propostaCartaDebitoIntSrvc.currentTipoCarta = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta;
          }

          // Anagrafica
          if (responses[1] && responses[1].data) {
            // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
            // dei dati mancanti nell'anagrafica. Quindi imposto il flag è disabilito il bottone
            // per proseguire
            self.anagraficaIncompleta = self.messaggiFctr.processaResponse(responses[1]);
            self.datiAnagrafici = responses[1].data.result.anagrafica || {
              contatti: {},
              documentoIdentificativo: {},
              indirizzoPrincipale: {},
              indirizzoSpedizione: {},
              enteRilascio: {}
            };
            self.datiAnagraficiOriginali = responses[1].data.result.anagraficaOriginale || {
              contatti: {},
              documentoIdentificativo: {},
              indirizzoPrincipale: {},
              indirizzoSpedizione: {},
              enteRilascio: {}
            };

            // Prevalorizzazione ente rilascio
            // Se non è presente nei dati aggiuntivi lo prendo da anagrafica
            if (
              !(
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
              )
            ) {
              if (self.datiAnagrafici.documentoIdentificativo) {
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio = {};
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio =
                  self.datiAnagrafici.documentoIdentificativo.enteRilascioDocumento;
                // RecuperaDomini viene chiamato in sequenza dopo questa chiamata, quindi la valorizzazione
                // onEnteChange di enteRilascio viene lasciata a recuperaDomini
              }
            }

            // Formattazione date
            if (self.datiAnagrafici.documentoIdentificativo.rilascioDocumento) {
              self.datiAnagrafici.documentoIdentificativo.rilascioDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
                );
            }
            if (self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento) {
              self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
                );
            }

            // Se non ho dati aggiuntivi, creo il payload con la sola id pratica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {
                idPratica: self.idPratica,
                indirizzoSpedizione: null,
                tae: null
              };
            }

            // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
              // L'indirizzo da utilizzare per la prevalorizzazione è quello del domicilio se presente, altrimenti quello di residenza
              self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
                ? self.datiAnagrafici.indirizzoCorrispondenza
                : self.datiAnagrafici.indirizzoPrincipale;

              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione = {
                via: self.indirizzoPrevalorizzazione.via,
                numero: null,
                provincia: self.indirizzoPrevalorizzazione.provincia,
                comune: {
                  valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
                },
                cap: self.indirizzoPrevalorizzazione.cap,
                nazione: self.indirizzoPrevalorizzazione.nazione,
                localita: self.indirizzoPrevalorizzazione.localita
              };

              // provo a recuperare l'indirizzo ed il civico (se riesco)
              try {
                var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                  self.indirizzoPrevalorizzazione.via
                );
                if (datiIndirizzoCivico) {
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via =
                	  self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero =
                    datiIndirizzoCivico.civico;
                }
              } catch (error) {}
            }
          }

          self.recuperaDomini();
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;
        self.propostaCartaDebitoIntSrvc.isRedirecting = false;
        self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf = null;
        self.recuperaAnagrafica();
      });
    };

    self.init();
  };

  CdintDatiAggiuntiviCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDatiAggiuntivi/cdintDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAggiuntiviComponent = {
    controller: CdintDatiAggiuntiviCtrl,
    controllerAs: 'cdintDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAggiuntivi', CdintDatiAggiuntiviComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintDatiAggiuntivi/cdintDatiAggiuntivi.cmpt.js
// module id = 6
// module chunks = 0